import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router";

import { HELP_INBOUNDS } from "@/constants/HelpUrls";
import MasterDetail from "@/design/layouts/MasterDetail";
import { setHelpUrl } from "@/store/reducers/ui";

import { useHotkey } from "@tanstack/react-hotkeys";

import Inbound from "./Inbound";
import InboundList from "./InboundList";

export default function Inbounds() {
  const params = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(setHelpUrl(HELP_INBOUNDS));
  }, [dispatch]);

  useHotkey("Alt+N", () => navigate(`/pbx/${params.pbxId}/call-flow/inbound-routes/new`));

  return <MasterDetail identifier="did" master={<InboundList />} detail={<Inbound />} />;
}
